export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./StoryThumbnail.vue?vue&type=template&id=1b8b9710&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/stories/StoryThumbnail.vue?vue&type=template&id=1b8b9710&
// module id = 891
// module chunks = 0